import React, {Component} from 'react'
import UserEditForm from "./form/edit.component.jsx"
import SideBar from '../common/layout/sidebar.component.jsx'

class UserNew extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')
    }


    render() {
        return (
            <div>
                <UserEditForm />
            </div>
        );
    }
}

export default UserNew


// WEBPACK FOOTER //
// ./src/user/new.component.jsx